import React, { useCallback, useState } from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import logoPNG from 'shared/img/logo.webp';
import SVG from 'components/SVG';
import AgentFeedback from 'features/AgentFeedback/desktop';

import { useSidebarMenu } from '../../data';
import telegramSVG from '../../data/img/telegram.svg';
import ListItem from './ListItem';

import feedbackSVG from '../../data/img/feedback.svg';

import InvitePlayer from './InvitePlayer';

import './Sidebar.scss';
import AgentPromotion from 'features/AgentFeedback/view/desktop/AgentPromotion/AgentPromotion';

const b = block('sidebar');

const Sidebar = ({ changeMenuOpen = () => null }) => {
  const locale = useSelector(state => state.locale.locale);
  const { links } = useSelector(state => state.agentFeedback);
  const semiAutoWithdrawalEnabled = useSelector(state => state.auth.semiAutoWithdrawalEnabled);

  const [openModal, changeOpenModal] = useState(false);

  const onCloseModal = useCallback(() => {
    changeOpenModal(false);
  }, []);

  const sidebarMenu = useSidebarMenu();

  return (
    <div className={b()}>
      <div className={b('logo-wrapper')}>
        <img src={logoPNG} className={b('logo')} alt="logo" />
      </div>
      <div className={b('menu')}>
        {sidebarMenu
          .map(section => {
            if (!section.children) return section;
            const filteredChildren = section.children.filter(child =>
              semiAutoWithdrawalEnabled ? true : child.title !== 'requestHistory',
            );
            return { ...section, children: filteredChildren };
          })
          .map(el => (
            <ListItem item={el} key={el.title} changeMenuOpen={changeMenuOpen} />
          ))}
      </div>
      {(links?.feedback?.['is_visible'] ?? true) ? (
        <div className={b('feedback-button')} onClick={() => changeOpenModal(true)}>
          <SVG className={b('feedback-button-icon')} svgProps={{ svg: feedbackSVG }} />
          {locale.addFeedbackLink}
        </div>
      ) : null}
      <a href="https://t.me/+iAaQsG7c78Q4OWFh" target="_blank" rel="noopener noreferrer" className={b('telegram-btn')}>
        <SVG svgProps={{ svg: telegramSVG }} className={b('telegram-icon')} />
        <span className={b('telegram-text')}>{locale.advertising}</span>
      </a>
      {openModal && <AgentFeedback closeFunction={onCloseModal} />}
      <InvitePlayer />
      <AgentPromotion />
    </div>
  );
};

export default Sidebar;
